import { backendManagement } from "../backendPlatform";

export const getTerminals = ( args ) => {
  return backendManagement.get("/terminals",  { params: { ...args } });
};